import React from "react";
import UserAvatar from "components/common/UserAvatar";

export interface MemberTagItem {
  /** id passed back to onRemove */
  id: string;
  /** label + initials/colour source */
  name: string;
  /** avatar image; falls back to coloured initials when absent */
  imageUrl?: string | null;
  /** pre-selected & non-removable, e.g. the entity that scopes the form (no × button) */
  locked?: boolean;
}

interface TeamMemberTagProps {
  item: MemberTagItem;
  onRemove: (id: string) => void;
  leading?: React.ReactNode;
}


const TeamMemberTag: React.FC<TeamMemberTagProps> = ({ item, onRemove, leading }) => (
  <div className="flex max-w-full items-center gap-2 bg-[#252B3B] border border-primary-subtle rounded-full px-3 py-2">
    {leading ?? (
      <UserAvatar
        name={item.name}
        profileImageURL={item.imageUrl}
        className="w-6 h-6 text-[10px]"
      />
    )}
    <span className="truncate text-sm text-neutral">{item.name}</span>
    {!item.locked && (
      <button
        type="button"
        onClick={() => onRemove(item.id)}
        className="ml-1 shrink-0 text-neutral-medium hover:text-red-500 transition-colors"
      >
        ×
      </button>
    )}
  </div>
);

export default TeamMemberTag;
